import { createContext, useContext, useState, useEffect } from "react";
import { FilterLink } from "./FilterLink";

const FilterContext = createContext();

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};

export const FilterProvider = ({ children }) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) return;

    const fetchCountries = async () => {
      setLoading(true);
      setError(null);
      try {
        const link = new FilterLink();
        await link.request();
        setCountries(link.countries);
        setInitialized(true);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, [initialized]);

  const value = {
    countries,
    loading,
    error,
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};
